import React from "react";
import { Layout } from "antd";

const { Footer: AntdFooter } = Layout;

const FooterComp = () => {
  return (
    <AntdFooter style={{ textAlign: "center" }}>
      AI-FacilFlow ©{new Date().getFullYear()} Created by RUSH.AI
    </AntdFooter>
  );
};

export default FooterComp;
